<textarea
  [attr.rows]="props.rows || 4"
  [errorStateMatcher]="errorStateMatcher"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="props.placeholder || ''"
  [required]="required"
  [tabIndex]="props.tabindex"
  matInput
  locktonAppsDynamicTextarea
></textarea>
